import { apiGet, apiPost } from './api';

export const createOrder = async (orderData) => {
  console.log('[ordersService] createOrder llamado con:', orderData);
  try {
    const response = await apiPost('/api/ecommerce/pedidos', orderData);
    const data = await response.json();
    console.log('[ordersService] Respuesta de createOrder:', data);
    
    // IMPORTANTE: NO mostrar ningún alert aquí - el componente CheckoutPage maneja el flujo
    // Si data.mensaje existe, lo ignoramos - no lo mostramos automáticamente
    
    return data;
  } catch (error) {
    console.error('[ordersService] Error al crear pedido:', error);
    throw error;
  }
};

export const getOrders = async (page = 1, limit = 10) => {
  try {
    const response = await apiGet(`/api/ecommerce/pedidos?page=${page}&limit=${limit}`);
    const data = await response.json();
    
    if (data.success) {
      return {
        pedidos: data.data.pedidos || [],
        pagination: data.data.pagination || null
      };
    }
    
    return { pedidos: [], pagination: null };
  } catch (error) {
    console.error('Error al obtener pedidos:', error);
    return { pedidos: [], pagination: null };
  }
};

export const getOrderById = async (pedidoId) => {
  try {
    const response = await apiGet(`/api/ecommerce/pedidos/${pedidoId}`);
    const data = await response.json();
    
    if (data.success) {
      return data.data.pedido;
    }
    
    return null;
  } catch (error) {
    console.error('Error al obtener pedido:', error);
    return null;
  }
};

export const cancelOrder = async (pedidoId) => {
  try {
    const response = await apiPost(`/api/ecommerce/pedidos/${pedidoId}/cancelar`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al cancelar pedido:', error);
    throw error;
  }
};

export const mapOrderToFrontend = (pedido) => {
  return {
    id: pedido.id,
    orderNumber: pedido.numero_pedido,
    status: pedido.estado,
    subtotal: parseFloat(pedido.subtotal),
    discount: parseFloat(pedido.descuento),
    shipping: parseFloat(pedido.envio),
    total: parseFloat(pedido.total),
    currency: pedido.moneda,
    shippingAddress: pedido.direccion_entrega,
    shippingMethod: pedido.metodo_envio,
    trackingNumber: pedido.tracking_number,
    observations: pedido.observaciones,
    items: (pedido.items || []).map(item => ({
      id: item.id,
      product: {
        id: item.producto.id,
        name: item.producto.nombre,
        image: item.producto.imagen_url
      },
      quantity: item.cantidad,
      unitPrice: parseFloat(item.precio_unitario),
      subtotal: parseFloat(item.subtotal)
    })),
    createdAt: pedido.created_at,
    updatedAt: pedido.updated_at
  };
};

export const getOrderStatusText = (status) => {
  const statusMap = {
    pendiente: 'Pendiente',
    confirmado: 'Confirmado',
    procesando: 'En Proceso',
    enviado: 'Enviado',
    entregado: 'Entregado',
    cancelado: 'Cancelado',
    reembolsado: 'Reembolsado'
  };
  
  return statusMap[status] || status;
};

/**
 * Obtener color para el estado del pedido
 */
export const getOrderStatusColor = (status) => {
  const colorMap = {
    pendiente: '#fbbf24',
    confirmado: '#3b82f6',
    procesando: '#8b5cf6',
    enviado: '#06b6d4',
    entregado: '#10b981',
    cancelado: '#ef4444',
    reembolsado: '#f97316'
  };
  
  return colorMap[status] || '#6b7280';
};

export default {
  createOrder,
  getOrders,
  getOrderById,
  cancelOrder,
  mapOrderToFrontend,
  getOrderStatusText,
  getOrderStatusColor
};